'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTransformAnimation = setTransformAnimation;
exports.throttle = throttle;
exports.primitiveEquals = primitiveEquals;
function setTransformAnimation(element, position) {
  var durationMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var prefixes = ['Webkit', 'Moz', 'ms', 'O', ''];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      element.style[value + 'Transition'] = 'transform ' + durationMs + 'ms ease-out';
      element.style[value + 'Transform'] = position ? 'translate3d(' + position + 'px, 0, 0)' : null;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function throttle(func) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var savedArgs = void 0,
      savedThis = void 0,
      isThrottled = false;

  function wrapper() {
    if (isThrottled) {
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments);
    isThrottled = true;

    setTimeout(function () {
      isThrottled = false;

      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }
  return wrapper;
}

function primitiveEquals(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/common.js
// module id = 464
// module chunks = 0